import React, { FunctionComponent, useState, useContext } from 'react';
import styles from './styles.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { LogoImage } from 'components/LogoImage';
import { NavLink, Link } from 'react-router-dom';
import { UserAgentContext } from 'features/user-agent/userAgent';
import classNames from 'classnames';
import { ThumbImage } from 'components/Images/ThumbImage';
import { CurrentUserMenu } from 'features/current-user/components/CurrentUserMenu';

export const ChannelHeader: FunctionComponent = () => {
  const [respNavigationShown, setRespNavigationShown] = useState(false);
  const channel = useSelector(
    (state: RootState) => state.channel.channelDetails
  );

  const { isNativeAppWebview } = useContext(UserAgentContext);

  const toggleMenu = () => {
    setRespNavigationShown(!respNavigationShown);
  };

  if (!channel || isNativeAppWebview) {
    return null;
  }

  return (
    <header data-testid="header" className={styles['channel-header']}>
      <Link to="/" className={styles['channel-header__logo']}>
        <LogoImage size={'medium'} hasFallback={!channel.logoKey}>
          <ThumbImage
            artworkKey={channel.logoKey}
            artworkMode={'logo'}
            alt={`Logo for ${channel.username}`}
          />
        </LogoImage>
      </Link>
      <button
        aria-controls="navigation"
        className={classNames(styles['channel-header__resp-nav'], {
          [styles['channel-header__resp-nav--expand']]: respNavigationShown
        })}
        onClick={toggleMenu}
      >
        <span>Menu</span>
      </button>
      <nav id="navigation" className={styles['channel-header__nav']}>
        <ul className="list--reset">
          <li>
            <NavLink to="/">Home</NavLink>
          </li>
          <li>
            <NavLink to="/events">Events</NavLink>
          </li>
          <li>
            <NavLink to="/recordings">Recordings</NavLink>
          </li>
          <li>
            <NavLink to="/about">About</NavLink>
          </li>
        </ul>
      </nav>
      <CurrentUserMenu />
    </header>
  );
};
